var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/StudentEditor/StudentEditor.css';
import { Pager } from 'react-bootstrap';

var $ = require('jquery');
var StudentClassRes = require('../../resources/studentclass');
import notification from '../Modal/notification';
import createNotificationDialog from '../Modal/createNotificationDialog';

//for getting and displaying students for the teacher/admin to add to this new class
// import StudentsTable from './StudentsTable';
import AddedStudentsTable from './AddedStudentsTable';//'./StudentClassEditor';
import StudentsTable from '../Students/StudentsTable';
import ClassLevelDropDownList from './ClassLevelDropdownList';
var StudentRes = require('../../resources/student');

const STUDENT_STATUSES = [{
    cols: ['firstName', 'lastName', 'email', 'phone', 'lastActivityDate'],
    notes: [
      ''
    ]
}];
const ITEM_LIMIT = 5;

var StudentClassEditor = React.createClass({
    componentWillReceiveProps: function(nextProps) {
    // this.setState({})
    },
    componentDidUpdate: function(prevProps) {
        window.onbeforeunload = function() {
            return '';
        }
    },
    componentWillUnmount: function() {
        window.onbeforeunload = function() {
            return undefined;
        }
    },
    componentDidMount: function() {

        var _this = this;
        var statusMode = this.state.statusMode;
        statusMode = STUDENT_STATUSES;
        var currentUser = Auth.getCurrentUser();
        // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
        // if (currentUser.role === 'admin') {
        //   statusMode = ADMIN_STATUSES;
        // } else  {
        //   statusMode = TEACHER_STATUSES;
        // }
        var currentMode = statusMode[0];

        // if (this.props.location.query.mode) {
        //   var mode = this.props.location.query.mode,
        //       mappedMode = statusMode.filter((value) => {
        //         return value.code === mode
        //       })[0];
        //   if (mappedMode) currentMode = mappedMode;
        // }

        // var addedList = _this.state.addedStudentsList;

        this.setState({
          isLoading: true,
          statusMode: statusMode,
          currentMode: currentMode,
          
        }, function() {
          // var count = statusMode.length;
          // for (var i = 0; i < statusMode.length; i++) {
          //   this.countCollectionInMode(statusMode[i], function() {
          //     count--;
          //     if (count <= 0) _this.forceUpdate();
          //   });
          // }

          var currentURL = window.location.href;
          if (currentURL.indexOf("edit")!==-1) {

            this.retrieveStudentsInThisClass();
          } else {
            this.retrieveStudents();
          }
          
        });
    },
    retrieveStudentsInThisClass: function(callback) {

        callback = callback || function(){};
        var _this = this;
        var currentPager = this.state.currentPager;
        var options = {};
        // options.skip = ITEM_LIMIT * (currentPager - 1);
        // options.limit = ITEM_LIMIT;
        // options.sort = this.state.sort || "dateCreated";
        options.conditions = {};
        
        var scName = '';
        // if (studentClassName) { scName = studentClassName; }

        var currentURL = window.location.href;
        currentURL = currentURL.split("/");
        var sClassID = currentURL[currentURL.length-1]; //get the current class ID
        // console.log("CLASS ID IS " + sClassID);
        options.conditions.sort = this.state.sort || "firstName";
        // options.conditions.status = 'student';
        options.conditions.studentClassID = sClassID;

        // options.conditions.lastName = lastN;
        StudentClassRes.retrieveStudentsInThisClass(options, function(err, res) {

            _this.setState({
                isLoading: false,
                studentClass: {
                    addedStudentsList: (!err && res) ? res: [{}],
                }
            }, () => {

                var sData = _this.state.studentClass.addedStudentsList;
                var sInClassData = sData["studentsInSelectedClass"];
                var sClassName = sData["studentClassName"];
                var sClassLevel = sData["studentClassLevel"];

                for (var i = 0; i < sInClassData.length; i++) {

                    var thisData = sInClassData[i];
                    var dDate = thisData['lastActivityDate'];
                    var processDate = new Date(dDate);
                    var dateToDisplay = processDate.toDateString();
                    if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
                    thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
                }

                // console.log("SETTING STATE FOR " + sClassLevel);

                _this.setState({
                    displayClassName: 'Editing ' + sClassName,
                    displayButtonText: 'Update Class',
                    studentClass: {
                        addedStudentsList: sInClassData,
                        studentClassName: sClassName,
                        studentClassLevel: sClassLevel,
                        _id: sClassID
                    },
                    retrievedClassLevel: sClassLevel
                }, function() {

                    this.retrieveStudents();
                });
            }
            // , function() {
                // _this.retrieveCollectionQuestionStat(function() {
                // if (_this.state.currentMode.showReviewStat) {
                //   var collections = _this.state.collectionData;
                //   for (var i = 0; i < collections.length; i++) {
                //     _this.retrieveCollectionTaskStat(collections[i]);
                //   }
                // }
                // });
                // return callback(err, res);
            // }
            );
        })
    },
    retrieveStudents: function(fName,lName,callback) {
        callback = callback || function(){};
        var _this = this;
        var currentPager = this.state.currentPager;
        var options = {};
        options.skip = ITEM_LIMIT * (currentPager - 1);
        options.limit = ITEM_LIMIT;
        // options.sort = this.state.sort || "dateCreated";
        options.conditions = {};
        // options.conditions.status = {
        //   "$in": this.state.currentMode.value
        // }
        // if (!this.state.currentMode.canApplyAdminRole) {
        //   options.conditions.creator = Auth.getCurrentUser()._id;
        // }
        // if (this.state.currentMode.include) {
        //   options.include = this.state.currentMode.include;
        //   options.includeConditions = includeConditions[options.include];
        // }
                // console.log("state of mdoe is " + this.state.currentMode.cols);
        var currentUser = Auth.getCurrentUser();
        if (currentUser.status && currentUser.status.indexOf('teacher') >= 0) {

            options.conditions.teacherID = currentUser._id;
        
        } else if (currentUser.status && currentUser.status.indexOf('admin') >= 0) {

            options.conditions.ifAdmin = 'true';
        }

        var firstN = '';
        var lastN = '';
        if (fName) { firstN = fName; }
        if (lName) { lastN = lName; }

        options.conditions.sort = this.state.sort || "dateCreated";
        options.conditions.status = 'student';
        options.conditions.firstName = firstN;
        options.conditions.lastName = lastN;
        options.conditions.doNotAdd = [];

        //TODO: add in a list of students to not retrieve as they have already been added to the addedStudentsList
        var addedStudents = _this.state.studentClass.addedStudentsList;
        var aCount = addedStudents.length;
        for (var x = 0; x < aCount; x++) {

            var thisAddedStudent = addedStudents[x];
            options.conditions.doNotAdd.push({
                'email':thisAddedStudent['email'],
                'firstName':thisAddedStudent['firstName'],
                'lastName':thisAddedStudent['lastName']
            });
        }

        StudentRes.retrieveStudents(options, function(err, res) {
            // console.log("BEFORE DON sdfdsfsE!!");
            // if (callback) return callback(err, res);
            // console.log("BEFORE DONE!!");

            _this.setState({

                isLoading: false,
                studentsData: (!err && res) ? res: [{}]

            }, () => {

                    //TODO: now check the students in this list against the db to see if any students are in any class. if so, remove the add to list button for them

                    var sData = _this.state.studentsData;
                    var sCount = sData.length;
                    for (var i = 0; i < sCount; i++) {

                        var thisData = sData[i];
                        var dDate = thisData['lastActivityDate'];
                        var processDate = new Date(dDate);
                        var dateToDisplay = processDate.toDateString();
                        if (processDate.getFullYear()==='1970') { dateToDisplay = '-';}
                        thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
                    }

                    _this.setState({
                        studentsData: sData
                    });
            // console.log("DONE!!!");
                }
            // , function() {
            // _this.retrieveCollectionQuestionStat(function() {
                // if (_this.state.currentMode.showReviewStat) {
                //   var collections = _this.state.collectionData;
                //   for (var i = 0; i < collections.length; i++) {
                //     _this.retrieveCollectionTaskStat(collections[i]);
                //   }
                // }
            // });
            // return callback(err, res);
            // }
            );
        })
    },
    getInitialState: function() {
        var _this = this;
        var initialState = {
            searchStudentName: '',
            displayClassName: 'New Class',
            displayButtonText: 'Create Class',
            statusMode: [],
            currentMode: {},
            studentsData: [],
            isLoading: true,
            // conceptsMap: null,
            currentPager: 1,
            sort: 'firstName',
            ifViewingFromClass: false,
            studentClass: {
                studentClassName : "",
                noOfStudents: 0,
                dateCreated: "",
                addedStudentsList: [],
                createdByTeacher: "",
                studentClassLevel: "Y1/P1",
                _id:""
            },
            retrievedClassLevel: ""
        }
        return initialState;
    },
    navigatePager: function(dir) {
        var currentPager = this.state.currentPager,
                  _this  =  this;
        currentPager += dir;
        _this.setState({
          currentPager: currentPager,
          isLoading: true
        }, function() {
          this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
          // this.retrieveStudents(function(err, res) {
          // })
        })
    },
    searchForStudent: function(e) {

        this.setState({
            searchStudentName: e.target.value,
            studentsData: [],
            isLoading: true,
            currentPager: 1,
            sort: 'firstName'
          }, () => {
            this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
        });
    },
    handleChangeClassLevel: function(e) {

        var _this = this;

        this.changeClassLevel(e.target.value);
    },
    changeClassLevel: function(studentClassLvl) {

        var updatedS = this.state.studentClass;
        updatedS.studentClassLevel = studentClassLvl;//e.target.value;
        // console.log("STUDENT CLASS LEVEL IS " + updatedS.studentClassLevel);
        this.setState({
            studentClass:updatedS
        });
    },
    handleChangeData: function(e) {
        var update = {};
        var _this = this;

        var updatedS = _this.state.studentClass;
        updatedS.studentClassName = e.target.value;

        this.setState({
            studentClass:updatedS
        })
        // var studentClass = _this.state.studentClass;
        // studentClass.studentClassName = e.target.value;
        // this.setState({ studentClass: studentClass });
        
        // studentClass[field] = e.target.value;
        // update[field] = e.target.value;
        // this.setState(update);
    },
    removeStudentFromClass: function(fName,lName,emailAddress) {

        var _this = this;

        let updatedAddedList = _this.state.studentClass.addedStudentsList;
        var noStudents = _this.state.studentClass.noOfStudents;
        var sName = _this.state.studentClass.studentClassName;
        var sID = _this.state.studentClass._id;

        var sCount = updatedAddedList.length;
        var indexToRemoveAt = 0;
        for (var x = 0; x < sCount; x++) {
            
            var thisRow = updatedAddedList[x];
            
            //if found the student to remove from the added students list
            if (thisRow.firstName === fName && thisRow.lastName == lName && thisRow.email === emailAddress) { 

                indexToRemoveAt = x;
                break;
            }
        }

        updatedAddedList.splice(indexToRemoveAt,1); //remove the student from the added students list table
        noStudents--; //decrease the number of students

        //set back the state
        this.setState({
            studentClass: {
                addedStudentsList:updatedAddedList,
                noOfStudents: noStudents,
                studentClassName: sName,
                _id: sID
            },
        }, () => {
            
            //now update the students list by retrieving from the db again
            this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
        });
    },
    addStudentToClass: function(fName,lName,emailAddress,_id) { //called when user addes a student to the temp list currently shown in the create new class UI

        var _this = this;
        // var studentList = _this.state.addedStudentsList.slice();

        let scLevel = _this.state.studentClass.studentClassLevel;

        //first check if this student has already been added to the list
        var addedList = _this.state.studentClass.addedStudentsList;
        var aCount = addedList.length;
        var ifAlreadyAdded = false;
        for (var i = 0; i < aCount; i++) {

            var addedStudent = addedList[i];
            
            if (addedStudent['firstName'] === fName && addedStudent['lastName'] === lName && addedStudent['email'] ===emailAddress) {

                ifAlreadyAdded = true;
                break;
            }
        }

        if (!ifAlreadyAdded) { //if this student has not been added yet

            var newAddStudent = {
                '_id':_id,
                'firstName':fName,
                'lastName':lName,
                'email':emailAddress
            };

            var sName = _this.state.studentClass.studentClassName;
            var sID = _this.state.studentClass._id;
            var noStudents = _this.state.studentClass.noOfStudents;
            noStudents++;


            let updatedAddedList = _this.state.studentClass.addedStudentsList.concat(newAddStudent);

            //find the newly added student and remove him from the students data list 
            var sData = _this.state.studentsData;
            var rowToRemove = 0;
            for (var i = 0; i < sData.length; i++) {

                var thisData = sData[i];
                var firstName = thisData['firstName'];
                var lastName = thisData['lastName'];
                var emailAdd = thisData['email'];

                if (firstName === fName && lastName === lName && emailAdd === emailAddress) { //if found the row, remove it

                    rowToRemove = i;
                    break;
                }
            }

            let modifiedStudentsData = _this.state.studentsData.slice();
            modifiedStudentsData.splice(rowToRemove,1);

            // this.setState({
            //     studentsData:modifiedStudentsData,
            //     addedStudentsList:updatedAddedList
            // });

            this.setState({
                studentClass: {
                    addedStudentsList:updatedAddedList,
                    noOfStudents: noStudents,
                    studentClassName: sName,
                    _id: sID,
                    studentClassLevel:scLevel
                },
                studentsData: [],
                isLoading: true,
                currentPager: 1,
                sort: 'firstName'
            }, () => {
                // this.searchForStudent();
                this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
            });
        }
    },
    deleteStudentClass: function(callback) {

        if (window.confirm('Are you sure you wish to delete this class?')) {

            var _this = this;
            var studentClass = _this.state.studentClass;

            var currentURL = window.location.href;
            currentURL = currentURL.split("/");
            var sClassID = currentURL[currentURL.length-1]; //get the current class ID
            // studentClass._id = sClassID;
            // var studentClassID = studentClass._id;

            $("body, html").addClass("heavy-load");
            StudentClassRes.deleteStudentClass(studentClass, (err, res) => {
                $("body, html").removeClass("heavy-load");
                if (callback) return callback(err, res);
                if (err) {
                    return notification.open({
                        message: 'Error',
                        description: 'Cannot delete class. Please try again'
                    });
                }
                // this.setState({
                //     studentClass: res
                // }, () => {
                notification.open({
                    message: 'Success',
                    description: "Class has been deleted!"
                });
                    browserHistory.push('/classes');
                    // if (_this.state.isCreateNew) browserHistory.push('/students');
                // })
            })
        }
    },
    saveStudentClass: function(callback) {

        var _this = this;
        var studentClass = _this.state.studentClass;
        var studentClassName = _this.state.studentClass.studentClassName;
        var studentClassLevel = _this.state.studentClass.studentClassLevel;
        
        //get number of students
        var noOfStudents = _this.state.studentClass.addedStudentsList.length;//_this.state.studentClass.noOfStudents;
        studentClass.noOfStudents = noOfStudents;

        var ifError = false;
        var errorDesc = 'All fields are required';

        var currentUser = Auth.getCurrentUser();
        var createdByTeacher = currentUser._id; //current user (teacher/admin's id)
        studentClass.createdByTeacher = createdByTeacher; //also get the id of this teacher creating the class

        if (studentClassName==null || studentClassLevel == null) { ifError = true; }
        else if (noOfStudents === 0) {

            ifError = true;
            errorDesc = 'Need to add minimum 1 student';
        }

        if (ifError) {

            return notification.open({
                message: 'Cannot Add Class',
                description: errorDesc
            })
            
            // return;
        } 
        else {

            $("body, html").addClass("heavy-load");
            StudentClassRes.saveStudentClass(studentClass, (err, res) => {
                $("body, html").removeClass("heavy-load");
                if (callback) return callback(err, res);
                if (err) {
                    return notification.open({
                    message: 'Error',
                    description: 'Cannot save class. Please try again'
                    })
                }
                this.setState({
                    studentClass: res
                }, () => {
                    notification.open({
                    message: 'Success',
                    description: "Class has been saved!"
                    })
                    browserHistory.push('/classes');
                    // if (_this.state.isCreateNew) browserHistory.push('/students');
                })
            })
        }
    },
    renderDeleteButton: function() {

        var currentURL = window.location.href;
        if (currentURL.indexOf("edit")!==-1) {
            return (
                <div className="deleteButtonDiv">
                    
                    <button
                        target="_blank"
                        value="Delete Class"
                        
                        onClick={this.deleteStudentClass.bind(this,null)}
                        className="deleteButton"
                    >DELETE CLASS</button>
                    
                </div>
            );
        }
    },
    render: function() {
        var _this = this;
        return (
            <div className="students">
                
                <h3> {_this.state.displayClassName} </h3>
                <br/>
                <div className="row createStudentRow">
                    <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent">Class Name</label>
                    </div>
                    <div className="col col-md-10 DivTxtCreateStudent">
                        <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData} value={_this.state.studentClass.studentClassName} />
                    </div>
                </div>
                <br/>

                <div className="row createStudentRow">
                    <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent">Class Level</label>
                    </div>
                    <div className="col col-md-10 DivTxtCreateStudent">
                        <ClassLevelDropDownList className="form-control mark-input createStudentField" 
                            selectedValue={this.state.studentClass.studentClassLevel}
                            handleChangeClassLevel={this.handleChangeClassLevel}
                            retrievedValue={this.state.retrievedClassLevel}
                        />
                    </div>
                </div>
                <br/>
                
                <div className="row createStudentRow">
                    <div className="col col-md-2 DivlblCreateStudent">
                        <label className="lblCreateStudent">Students</label>
                    </div>
                </div>

                {
                    (_this.state.studentClass.addedStudentsList.length > 0) &&

                    <AddedStudentsTable
                        data={this.state.studentClass.addedStudentsList}
                        mode={this.state.currentMode}
                        removeStudentFromClass={this.removeStudentFromClass}
                    />
                }
                <hr />
                <div className="row">
                
                    <div className="col col-md-10">
                        <input type="text" className="form-control mark-input searchStudentName" onChange={_this.searchForStudent} value={_this.state.searchStudentName} placeholder='Enter student name to search for'/>
                    </div>
                </div>
                <br/>
                {
                
                (_this.state.studentsData.length > 0 && !_this.state.isLoading) &&
                
                <StudentsTable
                    data={this.state.studentsData}
                    mode={this.state.currentMode}
                    sort={this.state.sort}
                    ifCreatingClass={true}
                    //onDelete={this.deleteCollection}
                    onSortChange={this.onSortChange}
                    addStudentToClass={this.addStudentToClass}
                    ifViewingFromClass={this.state.ifViewingFromClass}
                    //onUpdateSingleCollection={this.updateSingleCollection}
                />
                }

                {
                _this.state.isLoading &&
                <CircularProgress />
                }
                <Pager>
                {
                    _this.state.currentPager > 1 &&
                    <Pager.Item
                    onClick={_this.navigatePager.bind(_this, -1)}
                    disabled={_this.state.currentPager === 1}
                    >
                    Previous
                    </Pager.Item>
                }
                {' '}
                {
                    _this.state.studentsData.length >= ITEM_LIMIT &&
                    <Pager.Item
                    onClick={_this.navigatePager.bind(_this, 1)}
                    disabled={_this.state.studentsData.length < ITEM_LIMIT}
                    >
                    Next
                    </Pager.Item>
                }
                </Pager>
                
                <br/><br/>
                <div className="content-toolbar">
                    <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent"></label>
                    </div>
                    <div className="createButton">
                        
                        <RaisedButton
                            target="_blank"
                            label={_this.state.displayButtonText}
                            primary={true}
                            onClick={this.saveStudentClass.bind(_this, null)}
                        />
                        {/*<RaisedButton
                        onClick={this.saveStudent.bind(_this, null)}
                        target="_blank"
                        label="Create Student"
                        primary={true}
                        icon={<i style={{"color": "white"}} className="fa fa-save" />}
                        />*/}
                    </div>
                    {this.renderDeleteButton()}
                </div>
            
            </div>
        );
    }

});

export default StudentClassEditor;



/** WEBPACK FOOTER **
 ** ./src/components/StudentClassEditor/StudentClassEditor.js
 **/